import { useState } from 'react';

import { Box, Button, Container, Divider, Grid, Modal, Typography } from '@mui/material';

import Page from '...components/Page';
import useAuth from '...dashboard/hooks/useAuth';
import useSettings from '...hooks/useSettings';
import IntegrationGoogleWorkspace from '...sections/@dashboard/integrations/IntegrationGoogleWorkspace';
import IntegrationCard from '...sections/@dashboard/setup/IntegrationCard';

const title = 'Integrations';

export default function Integrations() {
  const { themeStretch } = useSettings();
  const { integrations } = useAuth();
  console.log('INTEGRATIONS IN PAGE:', integrations);

  const GoogleFetchIntegration = integrations && integrations.find(integration => integration?.type === 'GoogleFetch');

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Page title={`Dashboard | Setup | ${title}`}>
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <Box sx={{ mb: 5 }}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Box>
        <Divider />
        <Box sx={{ mt: 4, mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            Enterprise
          </Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <IntegrationCard title="Google Workspace" cta="Set Up" onClick={handleOpen} integration={GoogleFetchIntegration} />
          </Grid>
          <Grid item xs={12} md={4}>
            <IntegrationCard title="Microsoft" cta="Coming Soon" disabled />
          </Grid>
          <Grid item xs={12} md={4}>
            <IntegrationCard title="AWS" cta="Coming Soon" disabled />
          </Grid>
        </Grid>
        <Box sx={{ mt: 4, mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            Web3
          </Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <IntegrationCard title="Ethereum" cta="Coming Soon" disabled />
          </Grid>
        </Grid>
      </Container>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          background: 'rgb(22,28,36)'
        }}
      >
        <>
          <Button onClick={handleClose} sx={{ position: 'absolute', top: 20, right: 20 }}>
            <Typography variant="subtitle2">close</Typography>
          </Button>
          <Container
            sx={{
              overflow: 'auto',
              background: 'rgb(22,28,36)',
              height: '100%'
            }}
            maxWidth={false}
          >
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              direction="column"
              spacing={5}
            >
              <IntegrationGoogleWorkspace handleClose={handleClose} />
            </Grid>
          </Container></>
      </Modal>
    </Page>
  );
}
